import i18n from 'i18next';

export default ({ adminSettings, isInLiveMode, isChildLocale = false }) => {
  if (isChildLocale) return {};

  const { data: { locales } = {} } = adminSettings;

  return {
    author: {
      type: 'Text',
      label: i18n.t('author'),
      help: i18n.t('author-description'),
    },
    published_at: {
      type: 'Date',
      inputType: 'text',
      label: i18n.t('displayed-publish-date'),
      help: i18n.t('displayed-publish-date-description'),
      validators: [{ type: 'isISODateFormatted' }],
    },
    code: {
      type: 'Text',
      label: i18n.t('code'),
      help: i18n.t('code-description'),
      maxLength: 255,
    },
    ...(!isInLiveMode && {
      credit_units: {
        type: 'Text',
        label: i18n.t('credit-units'),
        help: i18n.t('credit-units-description'),
      },
    }),
    locale: {
      type: 'Select',
      label: i18n.t('locale'),
      selectProps: {
        isFluid: true,
        isFullWidth: true,
        placeholder: i18n.t('locales-placeholder'),
        noOptionsMessage: () => i18n.t('locales-empty'),
      },
      options:
        locales?.map(({ key, name }, i) => ({
          id: i,
          label: name,
          value: key,
        })) || [],
      isDisabled: true,
    },
  };
};
